import React from 'react';

export default function ErrorPlaceholder() {
  return (
    <div className="card-promo bg-white rounded shadow px-2 py-3 p-md-3 text-align-center">
      <h4 className="h3 text-primary">
        Sorry, we couldn't load any Live Games Data at this time
      </h4>
      <p className="text-dark-subtle mb-1">
        Please check back soon.
      </p>
    </div>
  );
}
